/**
 * FormDialog — vỏ dialog dùng chung cho các form Create/Update.
 * Children là body form; cha tự quản lý form state (RHF).
 */
import type { ReactNode } from 'react'
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'

export interface FormDialogProps {
  open: boolean
  title: string
  loading?: boolean
  submitText?: string
  cancelText?: string
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  onClose: () => void
  onSubmit: () => void
  children: ReactNode
  disableSubmit?: boolean
}

export function FormDialog({
  open,
  title,
  loading = false,
  submitText = 'Lưu',
  cancelText = 'Huỷ',
  maxWidth = 'sm',
  onClose,
  onSubmit,
  children,
  disableSubmit = false,
}: FormDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <Box component="form" noValidate>
          {children}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {cancelText}
        </Button>
        <Button
          onClick={onSubmit}
          variant="contained"
          color="primary"
          disabled={loading || disableSubmit}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {submitText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default FormDialog
